module.exports = __webpack_public_path__ + "static/img/ross_noble_ani_extended_size_00087-fs8.bbe8b0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/animation/ross_noble_ani_extended_size_00087-fs8.png
// module id = 240
// module chunks = 0